<template>
  <div class="editor-my-info">
    <!-- 头部导航 -->
    <mt-header title="微校园">
      <div slot="left">
        <mt-button icon="back" @click.stop="goback">
          <i class="iconfont icon-home" @click.stop="goHome"></i>
        </mt-button>
      </div>
    </mt-header>

    <!-- 表单-基础数据 -->
    <div>
      <div class="form-title">基本信息</div>
      <mt-field label="学生姓名" placeholder="请输入用户名" :disabled="disabled" :style="disabled ? 'background:#f2f2f2;':''" v-model="PersonObj.userName"></mt-field>
      <mt-field label="性别">
        <mt-radio v-model="PersonObj.sex" :options="sexOptions" disabled> </mt-radio>
      </mt-field>
      <mt-field label="民族" class="birth-data">
        <button @click="nationVisible = true" :style="PersonObj.nationality ? '':'color:#cbcbcb'">
          {{PersonObj.nationality ? PersonShow.natName:'请选择'}}
        </button>
      </mt-field>
      <mt-field label="血型" class="birth-data">
        <button @click="bloodTypeVisible = true" :style="PersonObj.bloodtype ? '':'color:#cbcbcb'">
          {{PersonObj.bloodtype ? PersonShow.bloodtypeName:'请选择'}}
        </button>
      </mt-field>
      <mt-field label="学生手机" v-model="PersonObj.mobile" :disabled="disabled" :style="disabled ? 'background:#f2f2f2;':''" placeholder="请输入" type="tel">
      </mt-field>
      <mt-field label="证件号码" v-model="PersonObj.idno" placeholder="请输入" type="tel"></mt-field>
      <mt-field label="出生日期" class="birth-data">
        <button :style="PersonObj.birthday ? '':'color:#cbcbcb'" @click="getDateBirth"> {{ PersonObj.birthday ?  PersonShow.birthday : '请选择' }} </button>
      </mt-field>
      <mt-field label="政治面貌" class="birth-data">
        <button @click="politicsVisible = true" :style="PersonObj.politics ? '':'color:#cbcbcb'">
          {{PersonObj.politics ? PersonShow.politicsName:'请选择'}}
        </button>
      </mt-field>
      <mt-field label="毕业学校" v-model="PersonObj.graduate" placeholder="请输入"></mt-field>
      <mt-field label="家庭电话" v-model="PersonObj.homephone" placeholder="请输入" type="tel"></mt-field>
      <mt-field label="邮箱" v-model="PersonObj.mail" placeholder="请输入" type="email"></mt-field>

      <div class="form-title">学籍信息</div>
      <mt-field label="学籍号" v-model="PersonObj.studentNo" placeholder="请输入" :disabled="disabled" :style="disabled ? 'background:#f2f2f2;':''" type="number"></mt-field>
      <mt-field label="考生号" v-model="PersonObj.candidateNo" placeholder="请输入" :disabled="disabled" :style="disabled ? 'background:#f2f2f2;':''" type="number"></mt-field>

      <mt-field label="行政班级" v-model="PersonObj.administrative" placeholder="请输入" :disabled="disabled" :style="disabled ? 'background:#f2f2f2;':''"></mt-field>
      <mt-field label="选考班级" v-model="PersonObj.xuanClassName" placeholder="请输入" :disabled="disabled" :style="disabled ? 'background:#f2f2f2;':''"></mt-field>
      <mt-field label="学考班级" v-model="PersonObj.xueClassName" placeholder="请输入" :disabled="disabled" :style="disabled ? 'background:#f2f2f2;':''"></mt-field>
      <mt-field label="选考科目" placeholder="请输入" v-model="PersonObj.chooseSubject" :disabled="disabled" :style="disabled ? 'background:#f2f2f2;':''"></mt-field>

      <mt-field label="入学年份" placeholder="请选择" v-model="PersonObj.entryYear" :disabled="disabled" :style="disabled ? 'background:#f2f2f2;':''"></mt-field>

      <mt-field label="入学日期" placeholder="请输入" v-model="PersonObj.enrollment"></mt-field>
      <mt-field label="在校状态" placeholder="请选择" v-model="PersonShow.statusName" :disabled="disabled" :style="disabled ? 'background:#f2f2f2;':''"></mt-field>
      <mt-field label="住宿走读" class="birth-data">
        <button @click="accommoDationVisible = true" :style="PersonObj.accommodation ? '':'color:#cbcbcb'">
          {{PersonObj.accommodation ? PersonShow.accommodationName:'请选择'}}
        </button></mt-field>
      <mt-field label="住宿安排" placeholder="请输入" v-model="PersonObj.stayarrange"></mt-field>
      <mt-field label="是否在籍" placeholder="请选择" v-model="PersonShow.stuStatusName" :disabled="disabled" :style="disabled ? 'background:#f2f2f2;':''"></mt-field>
      <mt-field label="纯文化生" placeholder="请选择" v-model="PersonShow.cultureStatusName" :disabled="disabled" :style="disabled ? 'background:#f2f2f2;':''"></mt-field>
      <div class="form-title">户口信息</div>
      <mt-field label="国家/地区" placeholder="请输入" v-model="PersonObj.countryarea"></mt-field>
      <mt-field label="户籍" placeholder="请输入" v-model="PersonObj.domicile"></mt-field>
      <mt-field label="家中子女数" placeholder="请输入" type="number" v-model="PersonObj.child"></mt-field>
      <mt-field label="户口性质" class="birth-data">
        <button @click="accountnatureVisible = true" :style="PersonObj.accountnature ? '':'color:#cbcbcb'">
          {{PersonObj.accountnature ? PersonShow.accountNatureName:'请选择'}}
        </button>
      </mt-field>
      <mt-field label="第几胎" placeholder="请输入" type="number" v-model="PersonObj.birth"></mt-field>
      <mt-field label="户籍类别" class="birth-data">
        <button @click="householdVisible = true" :style="PersonObj.household ? '':'color:#cbcbcb'">
          {{PersonObj.household ? PersonShow.householdName:'请选择'}}
        </button>
      </mt-field>
      <div class="form-title">家庭信息</div>
      <mt-field label="监护人一" placeholder="请输入" v-model="PersonObj.guardian1"></mt-field>
      <mt-field label="户口所在地" placeholder="请输入" v-model="PersonObj.hukouground1"></mt-field>
      <mt-field label="工作单位" placeholder="请输入" v-model="PersonObj.employer1"></mt-field>
      <mt-field label="职务" placeholder="请输入" v-model="PersonObj.jobtitle1"></mt-field>
      <mt-field label="手机号" placeholder="请输入" type="tel" v-model="PersonObj.phone1"></mt-field>

      <mt-field label="监护人二" placeholder="请输入" v-model="PersonObj.guardian2"></mt-field>
      <mt-field label="户口所在地" placeholder="请输入" v-model="PersonObj.hukouground2"></mt-field>
      <mt-field label="工作单位" placeholder="请输入" v-model="PersonObj.employer2"></mt-field>
      <mt-field label="职务" placeholder="请输入" v-model="PersonObj.jobtitle2"></mt-field>
      <mt-field label="手机号" placeholder="请输入" type="tel" v-model="PersonObj.phone2"></mt-field>
      <mt-field label="家庭住址" placeholder="省市县街道门牌号" v-model="PersonObj.address"></mt-field>
      <mt-field label="现在住址" placeholder="省市县街道门牌号" v-model="PersonObj.currentaddress"></mt-field>
      <mt-field label="上下学距离" placeholder="数字(公里)" type="number" v-model="PersonObj.distance"></mt-field>
      <mt-field label="上下学交通" class="birth-data">
        <button @click="atransportationVisible = true" :style="PersonObj.transportation ? '':'color:#cbcbcb'">
          {{PersonObj.transportation ? PersonShow.transportationName:'请选择'}}
        </button>
      </mt-field>
      <mt-field label="邮编" placeholder="请输入" type="number" v-model="PersonObj.postcode"></mt-field>

      <div class="form-title">其他信息</div>
      <mt-field label="才艺" placeholder="请输入" v-model="PersonObj.talent"></mt-field>
      <mt-field label="兴趣爱好" placeholder="请输入" v-model="PersonObj.hobby"></mt-field>
      <div class="btn-box">
        <mt-button class="confirm" type="primary" @click="operStudent('Ucenter')">确定</mt-button>
      </div>
    </div>
    <!-- 民族 -->
    <mt-actionsheet :actions="nationList" v-model="nationVisible"> </mt-actionsheet>
    <!-- 血型 -->
    <mt-actionsheet :actions="bloodTypeList" v-model="bloodTypeVisible"> </mt-actionsheet>
    <!-- 出生日期 -->
    <mt-datetime-picker ref="picker" type="date" v-model="pickerValue" @confirm="handleConfirm"> </mt-datetime-picker>
    <!-- 政治面貌 -->
    <mt-actionsheet :actions="politicsList" v-model="politicsVisible"> </mt-actionsheet>
    <!-- 入学年份 -->
    <!-- <mt-actionsheet :actions="nationList" v-model="nationVisible"> </mt-actionsheet> -->
    <!-- 在校状态 -->
    <!-- <mt-actionsheet :actions="nationList" v-model="nationVisible"> </mt-actionsheet> -->
    <!-- 住宿走读 -->
    <mt-actionsheet :actions="accommoDationList" v-model="accommoDationVisible"> </mt-actionsheet>
    <!-- 是否在籍 -->
    <!-- <mt-actionsheet :actions="nationList" v-model="nationVisible"> </mt-actionsheet> -->
    <!-- 纯文化生 -->
    <!-- <mt-actionsheet :actions="nationList" v-model="nationVisible"> </mt-actionsheet> -->
    <!-- 户口性质 -->
    <mt-actionsheet :actions="accountnatureList" v-model="accountnatureVisible"> </mt-actionsheet>
    <!-- 户籍类别 -->
    <mt-actionsheet :actions="householdList" v-model="householdVisible"> </mt-actionsheet>
    <!-- 上下学交通 -->
    <mt-actionsheet :actions="transportationList" v-model="atransportationVisible"> </mt-actionsheet>
  </div>
</template>

<script>
import { getUserInfo } from '@/service/user-service'
import Vue from 'vue';
import { Header, Field, Button, MessageBox, Radio, Toast, DatetimePicker, Popup, InfiniteScroll, Actionsheet } from 'mint-ui';
Vue.component(Actionsheet.name, Actionsheet);
Vue.use(InfiniteScroll);
Vue.component(Popup.name, Popup);
Vue.component(DatetimePicker.name, DatetimePicker);
Vue.component(Radio.name, Radio);
Vue.component(Button.name, Button);
Vue.component(Field.name, Field);
Vue.component(Header.name, Header);
export default {
  data() {
    return {
      isGoBack: false,
      disabled: true,
      birthToTime: '', //时间戳
      bloodTypeShow: '', // 血型选择
      bloodTypeVisible: false, //血型选择框
      bloodTypeList: [
        { name: 'A型血', id: '1', method: this.getBloodTyped },
        { name: 'B型血', id: '2', method: this.getBloodTyped },
        { name: 'O型血', id: '3', method: this.getBloodTyped },
        { name: 'AB型血', id: '4', method: this.getBloodTyped },
      ],

      nationVisible: false, //民族选择框
      nationList: [],
      pickerValue: '', //出生日期选择值
      DateBirthShow: '', //默认显示出生日期
      politicsList: [], //政治面貌列表
      politicsVisible: false, //政治面貌
      //获取户籍类别
      householdList: [
        { name: '常住', codeValue: '1', method: this.getHousehold },
        { name: '暂住', codeValue: '2', method: this.getHousehold }
      ],
      householdVisible: false, //显示户籍
      //   获取户口性质
      accountnatureList: [
        { name: '农业户口', codeValue: '1', method: this.getAccountNature },
        { name: '暂非农业户口住', codeValue: '2', method: this.getAccountNature }

      ],
      accountnatureVisible: false, //显示户口性质
      //   获取住宿走读
      accommoDationList: [
        { name: '住宿', codeValue: '1', method: this.getAaccommoDation },
        { name: '走读', codeValue: '2', method: this.getAaccommoDation }
      ],
      accommoDationVisible: false, //显示住宿走读
      //   获取上下学交通
      transportationList: [
        { name: '步行', codeValue: '1', method: this.getTransportation },
        { name: '自行车', codeValue: '2', method: this.getTransportation },
        { name: '公共交通', codeValue: '3', method: this.getTransportation },
        { name: '家长自行接送', codeValue: '4', method: this.getTransportation },
        { name: '校车', codeValue: '5', method: this.getTransportation },
        { name: '其他', codeValue: '6', method: this.getTransportation },
      ],
      atransportationVisible: false, //显示上下学交通
      sexOptions: [
        { label: '男', value: '1' },
        { label: '女', value: '2' }
      ],
      PersonShow: {
        birthday: '',
        householdName: '',
        natName: '', //民族
        accountNatureName: '',
        politicsName: '',
        accommodationName: '',
        bloodtypeName: '',
        transportationName: '',
        statusName: '',
        stuStatusName: '',
        cultureStatusName: '',
      },
      PersonObj: {
        name: '',
        userName: '', //学生姓名
        sex: '1', //性别
        nationality: '', //民族
        bloodtype: '', //血型
        mobile: '',  //学生手机
        idno: '', //证件号码
        birthday: '', //出生日期
        politics: '', //政治面貌
        graduate: '', //毕业学校
        homephone: '', //家庭电话
        mail: '', //邮箱
        studentNo: '', //学籍号
        candidateNo: '', //考生号
        administrative: '', //行政班级
        xuanClassName: '', //选考班级
        xueClassName: '', //学考班级
        chooseSubject: '', //选考科目
        entryYear: '',   //入学年份   
        enrollment: '', //入学日期
        status: '', //在校状态
        accommodation: '', //住宿走读
        stayarrange: '', //住宿安排
        stuStatus: '', //是否在籍
        cultureStatus: '', //纯文化生
        countryarea: '', //国家/地区
        domicile: '', //户籍
        child: '', //家中子女数
        accountnature: '', //户口性质
        birth: '', //第几胎
        household: '', //户籍类别
        guardian1: '', //监护人一
        hukouground1: '', //户口所在地
        employer1: '', //工作单位
        jobtitle1: '', //职务
        phone1: '', //手机号
        guardian2: '', //监护人二
        hukouground2: '', //户口所在地
        employer2: '', //工作单位
        jobtitle2: '', //职务
        phone2: '', //手机号
        address: '', //家庭住址
        currentaddress: '', //现在住址
        distance: '', //上下学距离
        transportation: '', //上下学交通
        postcode: '', //邮编
        talent: '', //才艺
        hobby: '', //兴趣爱好
        studentId: '',
        userId: '',
        oper: 'edit',
        schoolId: '',
      },
      map1: [],
      map2: [],
    }
  },
  mounted() {
    // 获取学校id
    getUserInfo().then(user => {
      this.PersonObj.studentId = user.studentId
      this.PersonObj.schoolId = user.user.schoolId
      this.PersonObj.userId = user.userId;
    })
    //获取个人信息
    this.getPersonCenter();
  },
  methods: {
    compareObjects() {
      const keys1 = Object.keys(this.PersonObj);
      for (let i = 0; i < keys1.length; i++) {
        const key = keys1[i];
        if (this.PersonObj[key] != this.map2[key]) {
          return false;
        }
      }
      return true
    },
    goback() {
      if (this.compareObjects()) {
        this.isGoBack = false
      } else {
        this.isGoBack = true
      }
      if (!this.isGoBack) {
        this.$router.replace({ name: 'Ucenter' });
      } else {
        MessageBox.confirm('是否保存修改信息?').then(action => {
          if (action == 'confirm') {
            this.operStudent('Ucenter')
          }
        }).catch(err => {
          if (err == "cancel") {
            this.$router.replace({ name: 'Ucenter' });
          }
        });
      }
    },
    goHome() {
      if (this.compareObjects()) {
        this.isGoBack = false
      } else {
        this.isGoBack = true
      }
      if (!this.isGoBack) {
        this.$router.replace({ name: 'Home' });
      } else {
        MessageBox.confirm('是否保存修改信息?').then(action => {
          if (action == 'confirm') {
            this.operStudent('Home');
            return
          }
        }).catch(err => {
          if (err == "cancel") {
            this.$router.replace({ name: 'Home' });
          }
        });
      }
    },
    // 获取个人信息
    getPersonCenter() {
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      this.$http.get('/api/edu/student/getStudent?userId=' + userInfo.userId).then(res => {
        // console.log(res.data, 'fffffffff', res);
        this.map2 = res.data
        this.map2.oper = 'edit';
        // if (res.statusText == 'OK') {
        //   console.log('sssssss');
        this.PersonObj.name = res.data.name; //学生姓名
        this.PersonObj.userName = res.data.userName; //学生姓名
        this.PersonObj.sex = res.data.sex //性别
        this.PersonObj.bloodtype = res.data.bloodtype //血型
        this.bloodTypeList.forEach(item => {
          if (res.data.bloodtype == item.id) {
            this.PersonShow.bloodtypeName = item.name
          }
        })
        this.PersonShow.natName = res.data.natName //民族
        this.PersonObj.nationality = res.data.nationality
        this.PersonObj.mobile = res.data.mobile  //学生手机
        this.PersonObj.idno = res.data.idno //证件号码
        this.PersonObj.birthday = res.data.birthday //出生日期
        this.PersonShow.birthday = res.data.birthday
        this.PersonObj.politics = res.data.politics //政治面貌
        this.PersonObj.graduate = res.data.graduate //毕业学校
        this.PersonObj.homephone = res.data.homephone //家庭电话
        this.PersonObj.mail = res.data.mail //邮箱
        this.PersonObj.studentNo = res.data.studentNo //学籍号
        this.PersonObj.candidateNo = res.data.candidateNo //考生号
        this.PersonObj.administrative = res.data.className //行政班级
        this.PersonObj.xuanClassName = res.data.xuanClassName //选考班级
        this.PersonObj.xueClassName = res.data.xueClassName //学考班级
        this.PersonObj.chooseSubject = res.data.chooseSubject //选考科目
        this.PersonObj.entryYear = res.data.entryYear  //入学年份 
        this.PersonObj.enrollment = res.data.enrollment //入学日期
        this.PersonObj.status = res.data.status //在校状态
        this.PersonObj.accommodation = res.data.accommodation //住宿走读
        this.PersonShow.accommodationName = res.data.accommodation == '1' ? '住宿' : '走读'
        this.PersonObj.stayarrange = res.data.stayarrange   //住宿安排
        this.PersonObj.stuStatus = res.data.stuStatus //是否在籍
        this.PersonShow.stuStatusName = res.data.stuStatus == '1' ? '在籍' : '不在籍'
        this.PersonObj.cultureStatus = res.data.cultureStatus //纯文化生
        this.PersonShow.cultureStatusName = res.data.cultureStatus == '1' ? '是' : '否'
        this.PersonObj.countryarea = res.data.countryarea  //国家/地区
        this.PersonObj.domicile = res.data.domicile  //户籍
        this.PersonObj.child = res.data.child  //家中子女数
        this.PersonObj.accountnature = res.data.accountnature   //户口性质
        this.accountnatureList.forEach(item => {
          if (res.data.accountnature == item.codeValue) {
            this.PersonShow.accountNatureName = item.name
          }
        })
        this.PersonObj.birth = res.data.birth  //第几胎
        this.PersonObj.household = res.data.household //户籍类别
        this.householdList.forEach(item => {
          if (res.data.household == item.codeValue) {
            this.PersonShow.householdName = item.name
          }
        })
        this.PersonObj.guardian1 = res.data.guardian1  //监护人一
        this.PersonObj.hukouground1 = res.data.hukouground1  //户口所在地
        this.PersonObj.employer1 = res.data.employer1  //工作单位
        this.PersonObj.jobtitle1 = res.data.jobtitle1  //职务
        this.PersonObj.phone1 = res.data.phone1  //手机号
        this.PersonObj.guardian2 = res.data.guardian2  //监护人二
        this.PersonObj.hukouground2 = res.data.hukouground2  //户口所在地
        this.PersonObj.employer2 = res.data.employer2  //工作单位
        this.PersonObj.jobtitle2 = res.data.jobtitle2  //职务
        this.PersonObj.phone2 = res.data.phone2  //手机号
        this.PersonObj.address = res.data.address  //家庭住址
        this.PersonObj.currentaddress = res.data.currentaddress  //现在住址
        this.PersonObj.distance = res.data.distance  //上下学距离
        this.PersonObj.transportation = res.data.transportation  //上下学交通
        this.transportationList.forEach(item => {
          if (res.data.transportation == item.codeValue) {
            this.PersonShow.transportationName = item.name
          }
        })
        this.PersonObj.postcode = res.data.postcode  //邮编
        this.PersonObj.talent = res.data.talent  //才艺
        this.PersonObj.hobby = res.data.hobby  //兴趣爱好
        // }
        // 获取政治面貌接口数据
        this.getQueryList();
        //   获取在校状态接口数据
        this.getStatusList();
        //   获取民族列表
        this.getNationalityList();

      })
    },
    // 获取民族列表
    getNationalityList() {
      this.$http.get('/api/admin/syscode/queryList?codeType=Nationality&schoolId=' + this.PersonObj.schoolId).then(res => {
        // if (res.statusText == 'OK') {
        //   console.log('获取民族列表');
        this.nationList = res.data.map(item => {
          item.name = item.codeName
          item.method = this.getNationData
          return item
        })
        //   console.log(this.nationList, 'ggggg');
        // }
        // console.log(this.nationList, 'sssssss');
      })
      //   console.log(this.nationList, 'aaaaaa');
    },
    // 获取政治面貌
    getQueryList() {
      this.$http.get('/api/admin/syscode/queryList?codeType=Politics&schoolId=' + this.PersonObj.schoolId).then(res => {
        // if (res.statusText == 'OK') {
        //   console.log(111111);
        this.politicsList = res.data.map(item => {
          item.name = item.codeName
          item.method = this.getPoliticsData
          if (this.PersonObj.politics == item.codeValue) {
            this.PersonShow.politicsName = item.codeName;
          }
          return item
        })
        // }
      })
    },
    // 获取在校状态
    getStatusList() {
      this.$http.get('/api/admin/syscode/queryList?codeType=Status&schoolId=' + this.PersonObj.schoolId).then(res => {
        // if (res.statusText == 'OK') {
        this.StatusList = res.data.map(item => {
          if (this.PersonObj.status == item.codeValue) {
            this.PersonShow.statusName = item.codeName;
          }
        })
        // }
      })
    },
    // 获取户籍类别
    getHousehold(val) {
      this.PersonShow.householdName = val.name
      this.PersonObj.household = val.codeValue
    },
    // 获取民族
    getNationData(val) {
      this.PersonShow.natName = val.name
      this.PersonObj.nationality = val.codeValue
    },
    // 获取户口性质
    getAccountNature(val) {
      this.PersonShow.accountNatureName = val.name
      this.PersonObj.accountnature = val.codeValue
    },
    // 获取政治面貌
    getPoliticsData(val) {
      this.PersonShow.politicsName = val.name
      this.PersonObj.politics = val.codeValue
    },
    //获取住宿走读
    getAaccommoDation(val) {
      this.PersonShow.accommodationName = val.name
      this.PersonObj.accommodation = val.codeValue
    },
    // 获取血型
    getBloodTyped(val) {
      this.PersonShow.bloodtypeName = val.name
      this.PersonObj.bloodtype = val.id
    },
    // 获取上下学交通
    getTransportation(val) {
      this.PersonShow.transportationName = val.name
      this.PersonObj.transportation = val.codeValue
    },
    handleConfirm() {
      if (!this.pickerValue) {
        this.$refs.picker.open();
        Toast('请选择日期');
        return;
      }
      this.birthToTime = new Date(this.pickerValue).getTime();
      this.PersonObj.birthday = this.timestampToTime(this.birthToTime);
      this.PersonShow.birthday = this.PersonObj.birthday
    },
    // 显示出生日期选择框
    getDateBirth() {
      this.$refs.picker.open();
    },

    timestampToTime(birthToTime) {
      if (birthToTime) {
        var date = new Date(birthToTime);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      } else {
        var date = new Date();
      }
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      return Y + M + D;
    },
    // 编辑保存信息
    operStudent(url) {
      $.ajax({
        url: '/api/edu/student/operStudent',
        type: 'post',
        data: this.PersonObj,
        dataType: 'json',
      }).then(res => {
        if (res.flag) {
          this.isGoBack = true;
          Toast({
            message: '保存成功',
            iconClass: 'mint-toast-icon mintui mintui-success'
          });
          this.$router.replace({ name: url });
        }
      })
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/user/editorMyIntro.vue